import { render, staticRenderFns } from "./AsideRight.vue?vue&type=template&id=0bc2b376&scoped=true&"
import script from "./AsideRight.vue?vue&type=script&lang=js&"
export * from "./AsideRight.vue?vue&type=script&lang=js&"
import style0 from "./AsideRight.vue?vue&type=style&index=0&id=0bc2b376&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc2b376",
  null
  
)

export default component.exports